module.exports = __webpack_public_path__ + "img/ascend_gold15.e68bff07.png";